<div class="container">
    <app-breadcrumb [crumbs]="crumbs"></app-breadcrumb>
    <form class="row gap-2" enctype="multipart/form-data" id="uploadFile">
        <div>
            <label class="form-control-label" for="upload"><b>Pdf upload</b></label>
            <input #pdfInput accept="application/pdf" class="form-control" id="upload" name="upload" type="file">
        </div>

        <div>
            <button (click)="underlayPdf(pdfInput.files[0])" class="btn btn-primary" name="download" type="button">Voeg achtergrond toe</button>
        </div>
    </form>

    <div>
        <span>Het verwachte formaat van de pdf inhoud is zoals te zien in het plaatje hieronder.</span>
        <br>
        <span>Als het plaatje niet zichtbaar is zijn de volgende formaten aan te houden :</span>
        <br>
        <span>Het formaat is : <strong>A4</strong>, met aan de <strong>bovenkant 3.5cm</strong> aan witruimte, <strong>linker en rechter kant 2.0cm</strong> wit ruimte en aan de <strong>onderkant 2.7cm</strong> witruimte</span>

        <h3><strong>Document marges:</strong></h3>
        <table class="table table-bordered a4-sizes text-center align-middle">
            <tbody>
                <tr class="top-height">
                    <td class="side-width"></td>
                    <td><strong>3.5 cm</strong></td>
                    <td class="side-width"></td>
                </tr>
                <tr>
                    <td class="side-width"><strong>2.0 cm</strong></td>
                    <td>Content of your document</td>
                    <td class="side-width"><strong>2.0 cm</strong></td>
                </tr>
                <tr class="bottom-height">
                    <td class="side-width"></td>
                    <td><strong>2.7 cm</strong></td>
                    <td class="side-width"></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
